import styles from './ShortCard.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setSlider} from "../../Reducer/GlobalReducer";
import Slide from "../Slide";
import {useIsMobile} from "../../Util/CheckMobile";
import WaitLoader from "../../WaitLoader/WaitLoader";
export default function ShortCard(){

    const location = useLocation()
    const dispatch = useDispatch()
    const  navigate = useNavigate()
    const isMobile = useIsMobile()
    const [tarifId, setTarifId] = useState<string>()
    const baseRegion = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })

    const tarifData = useRef<{
        regionId:number
        macroRegionId:number
        tarifId:string
    }>()

    const [ldrTarif,rsTarif,exTarif] = useApiQuery("/tarif/list","post",tarifData);
    const [dataCardItem, setDataCardItem] = useState()



    useEffect(()=>{
        //console.log(`location ` , location)
        const rg = new RegExp(`(?<=\\/short\\/).*$`,"ui")
        const match = location?.pathname?.match(rg)
        if(match)
        {
            setTarifId(match[0])
        }
        else  navigate('/')

    },[location])

    useEffect(()=>{
        loadTarifData()
    },[tarifId, baseRegion?.regionId])


    const  loadTarifData = () =>{
        if(tarifId === undefined) return
        tarifData.current = {
            macroRegionId: baseRegion?.macroRegionId ? baseRegion?.macroRegionId : -1  ,
            regionId: baseRegion?.regionId ? baseRegion?.regionId : -1,
            tarifId: tarifId

        }
        exTarif().then((e)=>{
            if(e?.success)
            {
                if(Array.isArray(e?.payload) && e?.payload?.length >0)
                {
                    setDataCardItem(e?.payload[0])
                    return
                }
            }
            setDataCardItem(undefined)
            //navigate('/')
        }).catch((e)=>{
            console.log(e)
            setDataCardItem(undefined)
            navigate('/')
        })
    }

    const buildSlide = () =>{
        if(dataCardItem) return(
            <div className={styles.scCont}>
                <Slide
                    item={dataCardItem}
                    key={0}
                    showConnect={true}
                ></Slide>
            </div>


        )
        return (
            <div className={styles.noTarif}>К сожалению в Вашем регионе тариф не доступен</div>
        )

    }

    return(
        <div className={styles.mainCont}>
            <div className={[styles.btnCont, isMobile ? "" : "d-none"].join(' ')}>
                <Link to={"/"} className={styles.link}>
                    <div className={styles.btnSelect}
                         onClick={()=>{
                             dispatch(setSlider({sliderMode:0}))
                             //sliderContext.setMode(0)
                             navigate('/')
                         }}
                    >Все тарифы</div>

                </Link>
            </div>
            <WaitLoader loading={ldrTarif} api={rsTarif} onlyLoading={true}>
                {buildSlide()}
            </WaitLoader>
            <div className={[styles.btnCont, isMobile ? "d-none" : ""].join(' ')}>
                <Link to={"/"} className={styles.link}>
                    <div className={styles.btnSelect}
                         onClick={()=>{
                             dispatch(setSlider({sliderMode:0}))
                             //sliderContext.setMode(0)
                             navigate('/')
                         }}
                    >Все тарифы</div>

                </Link>
            </div>
        </div>

    )
}
